import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import "../emitirCndGlobal.scss";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import api from "../../../services/api";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import ambiente from "../../../services/ambiente";

const ConfirmarDadosContribuinte = ({ location }) => {
  let dados = setDados();
  const [data] = useState(dados);
  const { prefeitura } = useParams();
  const history = useHistory();

  function setDados() {
    if (location.props !== undefined) {
      return location.props.dados;
    } else {
      return {};
    }
  }
  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.set("inscricao", data.inscricao);
      formData.set("cpfCnpj", data.cpfCnpj);
      formData.set("email", data.email);
      formData.set("fone", data.fone);
      formData.set("celular", data.celular);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      const response = await api.post(
        `cnd/contribuinte/emitir/${prefeitura}`,
        formData,
        config
      );
      if (response.data.damEmitido) {
        const protocolo = await api.get(`protocolo/${prefeitura}/${response.data.protocolo}`);
        window.open(
          `${ambiente.URL_API_PORTAL}pdf/dam/${prefeitura}/${response.data.protocolo}`
        );
        history.replace({
          pathname: `/${prefeitura}/acompanhamento/`,
          props: protocolo.data,
        });
      } else if (response.data.certidaoEmitida) {
        let protocolo;
        console.log("resp cnd", response.data);
        console.log("response data", response.data);
        if (response.data.externo) {
          protocolo = response.data.objProtocolo;

          protocolo = { ...protocolo, origem: 1, prefeituraId: response.data.prefeituraId };
        }
        else {
          const respProtocolo = await api.get(`protocolo/${prefeitura}/${response.data.protocolo}`);
          protocolo = respProtocolo.data;
          window.open(
            `${ambiente.URL_API_PORTAL}pdf/cnd/${prefeitura}/${response.data.protocolo}`
          );
        }
        console.log("dados protocolo", protocolo);
        history.replace({
          pathname: `/${prefeitura}/acompanhamento/`,
          props: protocolo,
        });
      } else {
        alert("Erro ao processar ação! Entre em contato com a prefeitura!");
      }
    } catch (err) { }
  }

  return (
    <React.Fragment>
      <div className={"content-block"}>
        <div className={"my-card responsive-paddings"}>
          <div className="input-box">
            <h2>Confirme seus dados</h2>
            <br></br>

            <form onSubmit={handleSubmit}>
              <Form formData={data} colCount={2}>
                <GroupItem
                  caption={"CERTIDÃO NEGATIVA DE DÉBITOS - CONTRIBUINTE"}
                  colSpan={2}
                  colCount={16}
                >
                  <SimpleItem colSpan={10} disabled={true} dataField={"nome"}>
                    <Label text="NOME/RAZÃO SOCIAL" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={3}
                    disabled={true}
                    dataField={"inscricao"}
                  >
                    <Label text="INSCRIÇÃO" />
                  </SimpleItem>
                  <SimpleItem colSpan={3} disabled={true} dataField={"cpfCnpj"}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={10}
                    disabled={true}
                    dataField={"endereco"}
                  >
                    <Label text="ENDEREÇO" />
                  </SimpleItem>
                  <SimpleItem colSpan={6} disabled={true} dataField={"bairro"}>
                    <Label text="BAIRRO" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={8}
                    disabled={true}
                    dataField={"complemento"}
                  >
                    <Label text="COMPLEMENTO" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={4}
                    disabled={true}
                    dataField={"cidadeUF"}
                  >
                    <Label text="CIDADE" />
                  </SimpleItem>
                  <SimpleItem colSpan={4} disabled={true} dataField={"cep"}>
                    <Label text="CEP" />
                  </SimpleItem>
                  <SimpleItem isRequired colSpan={8} dataField={"email"}>
                    <Label text="E-MAIL" />
                  </SimpleItem>
                  <SimpleItem isRequired colSpan={4} dataField={"fone"}>
                    <Label text="TELEFONE" />
                  </SimpleItem>
                  <SimpleItem isRequired colSpan={4} dataField={"celular"}>
                    <Label text="CELULAR" />
                  </SimpleItem>
                </GroupItem>
              </Form>
              <br></br>
              <br></br>
              <div className="grouping-items">
                <button
                  className={"button"}
                  style={{ color: "white", backgroundColor: "grey" }}
                  onClick={() => {
                    history.replace(`/${prefeitura}/cnd/contribuinte/`);
                  }}
                >
                  <FaRegArrowAltCircleLeft /> Voltar
                </button>
                <button type="submit" className="button">
                  Confirmar e Emitir
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConfirmarDadosContribuinte;
